/**
 * 回收站 接口列表
 */
import {backendUrl} from '@/assets/js/config'
import axios from '@/assets/plugins/axios'
import queryString from 'querystring'
let headers = {'Content-type': 'application/json'}
export default {
  // 1. 获取回收站 文件列表
  getRecycleList (params) {
    let URI = '/file/trash/list' // 回收站 清空
    if (params.projectId !== undefined) {
      URI = `/projects/${params.projectId}/trash` // 项目空间回收站 清空
    }
    return axios.get(`${backendUrl}` + URI, params)
  },
  // 1.1 回收站内 搜索
  searchRecycle (params) {
    let URI = '/file/trash/search' // 回收站 清空
    return axios.get(`${backendUrl}` + URI, params)
  },
  // 2. 清空回收站
  clearRecycle (params) {
    let URI = '/file/trash/empty' // 回收站 清空
    if (params.projectId !== undefined) {
      URI = `/projects/${params.projectId}/trash/empty` // 项目空间回收站 清空
    }
    return axios.delete(`${backendUrl}` + URI, params)
  },
  // 3. 回收站 彻底删除 fileId, projectId
  deleteRecycle (params) {
    let URI = '/file/trash/delete' // 回收站 彻底删除
    let query = {
      workspaceId: params.workspaceId
    }
    if (params.projectId !== undefined) {
      URI = `/projects/${params.projectId}/trash/delete` // 项目空间回收站 彻底删除
    }
    return axios.deleteArr(`${backendUrl}` + URI + '?' + queryString.stringify(query), params.fileInfo)
  },
  // 4. 回收站 还原
  restoreRecycle (params) {
    let URI = '/file/trash/restore' // 回收站 还原
    let query = {
      workspaceId: params.workspaceId
    }
    if (params.projectId !== undefined) {
      URI = `/projects/${params.projectId}/trash/restore` // 项目空间回收站 还原
    }
    return axios.postArr(`${backendUrl}` + URI + '?' + queryString.stringify(query), params.fileInfo, headers)
  }
}
